(function () {
    'use strict';

    run.parts.btnCopyData = function() {
        const btns_copy = document.querySelectorAll('.btn_copy_data');
        for (let i = 0; i < btns_copy.length; i++) {
            btns_copy[i].addEventListener('click', function(e) {
                const target = e.target.dataset.target;
                copyToClipboard(target);
                new Toast(translations.textCopied, Toast.TYPE_DONE, Toast.TIME_NORMAL);
            });
        }
    };
})();
